/* ============================================================================
   NOA — מעביר את כפתור ההוספה מתחת למוצר

   במבנה המקורי ‎quick-add-component‎ יושב בתוך ‎.card-gallery‎ — קופסת
   התמונה, שהיא ‎overflow: hidden‎ בגודל 189×189. לכן הכפתור נצבע מעל
   המוצר ומסתיר אותו. אי אפשר לפתור את זה ב-CSS בלבד בלי לפרוץ את
   החתיכה של גלריית התמונות, ולכן מעבירים את הצומת לסוף הכרטיס.

   לא נוגע בטופס, במזהה הווריאנט או במאזינים — רק מזיז צומת ב-DOM,
   ולכן ההוספה לסל ממשיכה לעבוד בדיוק כמו קודם.
   ========================================================================== */
(function () {
  'use strict';

  function relocate(root) {
    (root || document).querySelectorAll('quick-add-component').forEach(function (qa) {
      var card = qa.closest('.product-card__content');
      if (!card || qa.parentElement === card) return;
      card.appendChild(qa);
      qa.setAttribute('data-noa-moved', '');
    });
  }

  function init() {
    relocate(document);
    // רשת המוצרים מתחלפת בסינון ובעימוד — מריצים שוב על כל החלפה
    var obs = new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { relocate(document); return; }
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
